import axios from 'axios';
import get from 'lodash/get';

import { apiEndpoint } from '../../../util/apiHelpers';
import {
  getDefaultPhoneValueFromUser,
  getUserEmail,
} from '../../../util/user.path';

import {
  getListingEntity,
} from '../../../ducks/marketplaceData.duck';
import {
  $currentTx,
} from '../../TransactionPage/TransactionPage.duck';

export const sendInquireEmailMessage = ({
    state,
    unAuthUserData,
    listingId,
    message,
    isFinance,
    isInitiateTx,
  }) => {
  const url = `${apiEndpoint}/user/inquire-email-message`;
  const currentUser = get(state, 'user.currentUser', null);
  const firstName = get(unAuthUserData, 'firstName', get(currentUser, 'attributes.profile.firstName', ''));
  const lastName = get(unAuthUserData, 'lastName', get(currentUser, 'attributes.profile.lastName', ''));
  const phone = get(unAuthUserData,'phone', getDefaultPhoneValueFromUser(currentUser));
  const email = get(unAuthUserData, 'email',getUserEmail(currentUser));
  const listing = getListingEntity(state)(listingId);

  let toUserIdFromTx;
  if(!isInitiateTx) {
    const currTx = $currentTx(state);
    const providerId = currTx.provider.id.uuid;
    const customerId = currTx.customer.id.uuid;
    const currentUserId = currentUser.id.uuid;
    toUserIdFromTx = currentUserId === customerId ? providerId : customerId;
  }

  const toUserIdFromListing = get(listing, 'author.id.uuid', null);

  const leads = isFinance ? [
    {
      Lead_Source: 'aircraftforsale.com',
      Last_Name: lastName,
      First_Name: firstName,
      Email: email,
      Phone: phone,
      Equip_Price: get(listing, 'attributes.price.amount', 0) / 100,
      New_Used: get(listing, 'attributes.publicData.condition', ''),
      Equip_Year: get(listing, 'attributes.publicData.year', '').toString(),
      Equip_Make: get(listing, 'attributes.publicData.maker_name', ''),
      Equip_Model: get(listing, 'attributes.publicData.model_name', ''),
      Equip_Type_Descript: get(listing, 'attributes.publicData.summary_desc', ''),
      Equipment_Location: get(listing, 'attributes.publicData.aircraft_loc.selectedPlace.address', ''),
      FAA_Registration_No: get(listing, 'attributes.publicData.reg_num', ''),
      Equip_Serial_No: get(listing, 'attributes.publicData.serial_num', ''),
      Equipment_Delivery: get(window, 'location.href', ''),
    },
  ] : null;

  return axios.post(url, {
    toUserId: !isInitiateTx ? toUserIdFromTx : toUserIdFromListing,
    listing,
    email,
    firstName,
    lastName,
    message,
    ...(phone && { phone }),
    ...(leads && { leads }),
    ...(isInitiateTx && { isInitiateTx }),
  });
};
